import * as React from 'react'
import {Link} from '@frontrow/console/src/components/ui/link'

import * as style from './sidebar-link.module.scss'

type Props = {
  url: string
  title: string
  dataTest: string
}

export default function SidebarLink(props: Props): React.ReactElement {
  const {title, url, dataTest} = props

  return (
    <li className={style.sidebarLink}>
      <Link href={url} addClass={style.sidebarLinkA} dataTest={dataTest} reactRouter>
        {title}
      </Link>
    </li>
  )
}
